import { SyncIdentificationDexieService } from '@/contexts/sync-managements/database-service';
import { ListSimpleAnimalResponseSimpleAnimalsItem } from '@/query';
import { fDateBetween } from '@/shared/utils/format-time';

interface Props {
  oxen: ListSimpleAnimalResponseSimpleAnimalsItem[];
  gtaId: number;
  age: number;
}

const databaseService = new SyncIdentificationDexieService();

/** Representa as faixas etárias permitidas para os animais (em meses). */
type AgeRange = '0-12' | '13-24' | '25-36' | '36+';

/**
 * Calcula a faixa etária correspondente a uma dada idade em meses.
 *
 * @param ageInMonths - A idade do animal em meses.
 * @returns A faixa etária correspondente.
 */
function getAgeRange(ageInMonths: number): AgeRange {
  if (ageInMonths <= 12) return '0-12';
  if (ageInMonths <= 24) return '13-24';
  if (ageInMonths <= 36) return '25-36';
  return '36+';
}

export async function getCandidateOx({ oxen, gtaId, age }: Props) {
  const offlineOxen = await databaseService.getSuccessData();

  const sanitizeOxen = oxen
    .filter((item) => item.ox.gtaId === gtaId)
    .map((item) => ({
      id: item.ox.id,
      gender: item.ox.gender,
      age: fDateBetween(item.ox.birth, item.ox.includedAt, 'month')
    }));

  const listOxen = sanitizeOxen.filter((ox) => !offlineOxen.some((offlineOx) => offlineOx.oxId === ox.id));

  const targetAgeRange = getAgeRange(age);

  for (const ox of listOxen) {
    const currentOxAgeRange = getAgeRange(ox.age);

    if (currentOxAgeRange === targetAgeRange) {
      return ox;
    }
  }

  return null;
}
